import { Attendance } from "@/@types/sintegrada/Attendance";
import { sintegradaApi } from "@/services/api";

export type EvasionsInMedicalAttendanceParams = {
	uf: string;
	ibgeCode: string;
	startDate: string;
	endDate: string;
	cnes?: string;
	youngerAge?: number;
	olderAge?: number;
};

export async function getEvasionsInMedicalAttendance({
	uf,
	ibgeCode,
	...params
}: EvasionsInMedicalAttendanceParams) {
	const response = await sintegradaApi.get<Attendance[]>(
		`/uf/${uf}/city/${ibgeCode}/attendance/evasions-in-medical-attendance`,
		params
	);
	return response.data || [];
}
